document.addEventListener("DOMContentLoaded", () => {
    const page = document.querySelector("[data-results-page]");
    const dataNode = document.querySelector("#results-demo-data");

    if (!page || !dataNode) {
        return;
    }

    const routes = JSON.parse(dataNode.textContent || "[]");
    const routesTarget = page.querySelector("[data-results-routes]");
    const categoriesTarget = page.querySelector("[data-results-categories]");
    const agesTarget = page.querySelector("[data-results-ages]");
    const tableBody = page.querySelector("#participants-table-wrapper tbody");

    if (!routes.length || !routesTarget || !categoriesTarget || !agesTarget || !tableBody) {
        return;
    }

    let currentRouteId = routesTarget.querySelector(".results-page__route-button.is-active")?.dataset.routeId || routes[0].id;
    let currentCategoryId = categoriesTarget.querySelector("[data-results-category-button].active")?.dataset.categoryId
        || routes.find((route) => route.id === currentRouteId)?.categories?.[0]?.id
        || "general";
    let currentAgeGroupId = agesTarget.querySelector("[data-results-age-group-button].active")?.dataset.ageGroupId
        || routes.find((route) => route.id === currentRouteId)?.age_groups?.[currentCategoryId]?.[0]?.id
        || "";

    function getCurrentRoute() {
        return routes.find((route) => route.id === currentRouteId) || routes[0];
    }

    function syncUrl() {
        const url = new URL(window.location.href);
        url.searchParams.set("circle", currentRouteId || "");
        url.searchParams.set("category", currentCategoryId || "");

        if (currentAgeGroupId) {
            url.searchParams.set("age_group", currentAgeGroupId);
        } else {
            url.searchParams.delete("age_group");
        }

        window.history.replaceState({}, "", url.toString());
    }

    function getCurrentRows() {
        const route = getCurrentRoute();
        return route.rows?.[currentCategoryId]?.[currentAgeGroupId] || [];
    }

    function renderRoutes() {
        routesTarget.querySelectorAll(".results-page__route-button").forEach((button) => {
            button.classList.toggle("is-active", button.dataset.routeId === currentRouteId);
        });
    }

    function renderCategories() {
        const route = getCurrentRoute();

        categoriesTarget.innerHTML = route.categories.map((category) => `
            <button
                type="button"
                class="button button--small-xs button--secondary-border ${category.id === currentCategoryId ? "active" : ""}"
                data-category-id="${category.id}"
                data-results-category-button
            >
                <span>${category.label}</span>
            </button>
        `).join("");
    }

    function renderAges() {
        const route = getCurrentRoute();
        const ageGroups = route.age_groups?.[currentCategoryId] || [];

        if (!ageGroups.length) {
            agesTarget.innerHTML = "";
            currentAgeGroupId = "";
            return;
        }

        if (!ageGroups.find((item) => item.id === currentAgeGroupId)) {
            currentAgeGroupId = ageGroups[0].id;
        }

        agesTarget.innerHTML = ageGroups.map((ageGroup) => `
            <button
                type="button"
                class="button button--small-xs button--secondary-border ${ageGroup.id === currentAgeGroupId ? "active" : ""}"
                data-age-group-id="${ageGroup.id}"
                data-results-age-group-button
            >
                <span>${ageGroup.label}</span>
            </button>
        `).join("");
    }

    function renderTable() {
        const rows = getCurrentRows();

        if (!rows.length) {
            tableBody.innerHTML = `
                <tr>
                    <td colspan="7" class="text-center">Нет результатов</td>
                </tr>
            `;
            return;
        }

        tableBody.innerHTML = rows.map((row) => `
            <tr>
                <td>
                    <div class="results-page__place">
                        <span>${row.place ?? "—"}</span>
                        ${row.medal ? `<span class="results-page__medal" aria-hidden="true">${row.medal}</span>` : ""}
                    </div>
                </td>
                <td>${row.bib_number ?? "—"}</td>
                <td>${row.full_name ?? "—"}</td>
                <td>${row.age ?? "—"}</td>
                <td class="${row.result_status === "disqualified" ? "text-red-600 font-bold" : ""}">${row.finish_time ?? "—"}</td>
                <td>${row.previous_time ?? "—"}</td>
                <td>${row.leader_time ?? "—"}</td>
            </tr>
        `).join("");
    }

    function render() {
        renderRoutes();
        renderCategories();
        renderAges();
        renderTable();
        syncUrl();
    }

    routesTarget.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-route-id]");

        if (!trigger) {
            return;
        }

        currentRouteId = trigger.dataset.routeId;
        currentCategoryId = getCurrentRoute().categories?.[0]?.id || "general";
        currentAgeGroupId = getCurrentRoute().age_groups?.[currentCategoryId]?.[0]?.id || "";
        render();
    });

    categoriesTarget.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-category-id]");

        if (!trigger) {
            return;
        }

        currentCategoryId = trigger.dataset.categoryId;
        currentAgeGroupId = getCurrentRoute().age_groups?.[currentCategoryId]?.[0]?.id || "";
        render();
    });

    agesTarget.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-age-group-id]");

        if (!trigger) {
            return;
        }

        currentAgeGroupId = trigger.dataset.ageGroupId;
        render();
    });

    render();
});
